
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index65yp2VmpglzRJzJISGnjt8_9xmlRqFq0qGRgLACvJDsMeta } from "/app/packages/frontend/app/pages/index.vue?macro=true";
import { default as index_46client0zPajiQyZHKXnphwm6XzNDPUVi3CyQSa4WaCjOEVqiUMeta } from "/app/packages/frontend/app/pages/tablet/index.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/app/node_modules/.pnpm/nuxt@3.18.0_@capacitor+preferences@7.0.1_@capacitor+core@7.4.2__@netlify+blobs@9.1.2_@p_bfa5f24d81766dba992c52a6d53e701f/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as login_46clientaJ1FPYzoLXEN8KBq1KLjJv9EBUi5UszF3kEvT_9AxzMMeta } from "/app/packages/frontend/app/pages/tablet/login.client.vue?macro=true";
import { default as _91id_93RxBI8cJV6ljyZnOY4obBQJiBIkMIJ9FjDBfYu89_45_WcMeta } from "/app/packages/frontend/app/pages/live/[id].vue?macro=true";
import { default as loginFfMqkNXI_45M_lXnfLGuBE1NJVjonXeUR2VrLzydH8p2MMeta } from "/app/packages/frontend/app/pages/auth/login.vue?macro=true";
import { default as indexL0RWRSM4DqOI3pHiWndSi6_45Tk4BBILsAjaQyCmV8me0Meta } from "/app/packages/frontend/app/pages/play/index.vue?macro=true";
import { default as lobbyrv3xWBbaz_45Jxg0_456s1DhUYtIgJvqK1TYrgF_45IpRxKxYMeta } from "/app/packages/frontend/app/pages/play/lobby.vue?macro=true";
import { default as test_45loginmHWjaMvqIgFl9bObR0xBwRBJn7YmNDwtZ0sk5bMmB1QMeta } from "/app/packages/frontend/app/pages/test-login.vue?macro=true";
import { default as indexOvw4ei31YXRgdR2cfiQBR4ynQ6ZL_O_45mwZv6G5K6FMsMeta } from "/app/packages/frontend/app/pages/admin/users/index.vue?macro=true";
import { default as edit6aCzUMM_eRK209uQPl6ex_45FNWqTnU7vg2bCfi3BUmHEMeta } from "/app/packages/frontend/app/pages/admin/users/[user_id]/edit.vue?macro=true";
import { default as usersml8o3yB2_45CYxMI3MhxYB8zuHmq71i_45Vc4s845amGBM0Meta } from "/app/packages/frontend/app/pages/admin/users.vue?macro=true";
import { default as indexVHWR8yb3fvmPrffcXEJng_elyckYbPOYyw6xzkqK31MMeta } from "/app/packages/frontend/app/pages/manage/index.vue?macro=true";
import { default as registertvbiYupARYf35jgh2Apc2Ep7xeegwLHKNubspqtLA2QMeta } from "/app/packages/frontend/app/pages/auth/register.vue?macro=true";
import { default as indexo_454hjjcOPlSsZHlrxtp_3bgKoL01aYzGeYIOb4PSErQMeta } from "/app/packages/frontend/app/pages/profile/index.vue?macro=true";
import { default as _91id_93PwJyifhvnaSkgvA8eGUGP41LYf9eXWvF4nSKs5gSnx0Meta } from "/app/packages/frontend/app/pages/rankings/[id].vue?macro=true";
import { default as _91event_93zgOiriq2TI4OWAfPtuWy18vwUh1fgPp_458axm70_IL7UMeta } from "/app/packages/frontend/app/pages/events/[event].vue?macro=true";
import { default as privacy_45policymX4EBpnvPTaB037yFJrMtDgz2QOO4gdBrnMUmcAhDHMMeta } from "/app/packages/frontend/app/pages/privacy-policy.vue?macro=true";
import { default as indexPGdVviprZ5vjngqkqpyCD61hLh_b9cFBI5ozOfkKH0kMeta } from "/app/packages/frontend/app/pages/rankings/index.vue?macro=true";
import { default as my_45statsQ69ro7iTAMrN4_45oefvY4FUtuKTyoMCs0gZpidDkcL6oMeta } from "/app/packages/frontend/app/pages/profile/my-stats.vue?macro=true";
import { default as settingsavv21Jd_0BnioSGOt_45Ok2Epjk5DsGXctru00Yl9DcmkMeta } from "/app/packages/frontend/app/pages/profile/settings.vue?macro=true";
import { default as terms_45of_45serviceaGe9wj9p7rvfDMPHqp7sbJiU_45ZLqsglKP_45iyKbZ_bY4Meta } from "/app/packages/frontend/app/pages/terms-of-service.vue?macro=true";
import { default as indexHPDCB0MEDFcASm7cOymky6iRaVlsuIRsRwsuz3273oQMeta } from "/app/packages/frontend/app/pages/competition/index.vue?macro=true";
import { default as index4t6p5ROXKibBp1U0uxaowiLWkSRQHOn071P9mwBEWC4Meta } from "/app/packages/frontend/app/pages/tournaments/index.vue?macro=true";
import { default as my_45matchesbHIjXBhJXYqr2nM5ik_3ETLSyeReXWuP_iqiHsGIj_45IMeta } from "/app/packages/frontend/app/pages/profile/my-matches.vue?macro=true";
import { default as indexz_hzJZfT_vvq2XWUMIXT8PQeX7LmBnkWpXWPrqv7U24Meta } from "/app/packages/frontend/app/pages/admin/organisations/index.vue?macro=true";
import { default as createaaa3W_oWoKoTviA4ujzZ4Piyf1_45lm1QcnozmmKdVjFsMeta } from "/app/packages/frontend/app/pages/admin/organisations/create.vue?macro=true";
import { default as editMLCjWwkwqXBdQCP4DkW_87KG1570R0CmVR_pVcFEt5AMeta } from "/app/packages/frontend/app/pages/admin/organisations/[org_slug]/edit.vue?macro=true";
import { default as indexNyMxgUjoifAmwYykCmVVV0Cev9TvpvWhXKFqHIGt9U0Meta } from "/app/packages/frontend/app/pages/admin/organisations/[org_slug]/index.vue?macro=true";
import { default as _91org_slug_93nxa2YR5a_4568YvUPg8e44VIexah8zXfMcL6Q2gig_8zkMeta } from "/app/packages/frontend/app/pages/admin/organisations/[org_slug].vue?macro=true";
import { default as organisations7HPq7ICiLi6og6R7peWRSsS0NgnTaFOqnczrGcVx92QMeta } from "/app/packages/frontend/app/pages/admin/organisations.vue?macro=true";
import { default as reset_45passwordS6jdXf3OFPPwomV6KYjm6X2_45REy65se_45MfAhrESs2nAMeta } from "/app/packages/frontend/app/pages/auth/reset-password.vue?macro=true";
import { default as offline_46clientN0nZbc8NW4Idx_6s50sh670bkIVXIonhinH7Bwjm9E0Meta } from "/app/packages/frontend/app/pages/play/offline.client.vue?macro=true";
import { default as indexEcq_45IBIS37SbG5g_45ByZi94X799ODekW1m8Kv_ZgolKsMeta } from "/app/packages/frontend/app/pages/play/training/index.vue?macro=true";
import { default as statsXUnootcwZZagJCHmNKeX7fscMzp4jHImsJ3lwGHH6X4Meta } from "/app/packages/frontend/app/pages/play/training/stats.vue?macro=true";
import { default as createjFpwhtpq9QUESQBQ7s7QERQbbKBvjYGN0uzNBC70OVoMeta } from "/app/packages/frontend/app/pages/manage/events/create.vue?macro=true";
import { default as _91id_93_46clientPn_5R0jcUw2O8Y__456f57tiaA_qRN72_459LLLECSYVnmoMeta } from "/app/packages/frontend/app/pages/play/bot/[id].client.vue?macro=true";
import { default as index6vs_jCJnQlG9c3JgsfmwBTAXI1d4hsM6QlYbuEY241oMeta } from "/app/packages/frontend/app/pages/manage/rankings/index.vue?macro=true";
import { default as createoo4Ac3jr4IzZ_D1JqUl6rodfOdcaIa_gpe0GdSwByqYMeta } from "/app/packages/frontend/app/pages/manage/rankings/create.vue?macro=true";
import { default as my_45tournamentsKta3_454oQKJXQMit3__45c2ES9WpwfgjxMMl8L3uCnSsb0Meta } from "/app/packages/frontend/app/pages/profile/my-tournaments.vue?macro=true";
import { default as events_45locationsVYAl8ygsLSD1BNxZ08P3HwBG5FMuGDdQu1U1YyeTqUEMeta } from "/app/packages/frontend/app/pages/manage/events-locations.vue?macro=true";
import { default as editJ_45aUhynSRlusVpAGlKvnQED7HXgy981JHRvEQEMsLcoMeta } from "/app/packages/frontend/app/pages/manage/events/[id]/edit.vue?macro=true";
import { default as indexSjV4LQTL1oxZp6adRXtbIcvRYXVK_ayHw2nv4QlTnvUMeta } from "/app/packages/frontend/app/pages/manage/tournaments/[id]/index.vue?macro=true";
import { default as playersk_45cQ_45X4jN65_457LO54XeqnNkukhI4yse42JxmJc7J56wMeta } from "/app/packages/frontend/app/pages/manage/tournaments/[id]/players.vue?macro=true";
import { default as listOSP_QLompDzEHLTuGSdMTcFTXhuMzIpdOajQD9InGMIMeta } from "/app/packages/frontend/app/pages/manage/tournaments/[id]/play/list.vue?macro=true";
import { default as groups0V20NgPexO8nMA_dyYXhhWGQPzjNOSLqMecOEUOn6XUMeta } from "/app/packages/frontend/app/pages/manage/tournaments/[id]/play/groups.vue?macro=true";
import { default as resultszgKn1yZyXH3mWXf8lyYft25L8zJZHV17tRXhLXfxR58Meta } from "/app/packages/frontend/app/pages/manage/tournaments/[id]/play/results.vue?macro=true";
import { default as losers_45koaCnFUMFMG3Hty5WjsgiqUwLls67OZFfAyqS8xlLUn2IMeta } from "/app/packages/frontend/app/pages/manage/tournaments/[id]/play/losers-ko.vue?macro=true";
import { default as winners_45koDLmls16fZk67Zf2fVTr37uBpllu_YHqLaUjvRRfCzlUMeta } from "/app/packages/frontend/app/pages/manage/tournaments/[id]/play/winners-ko.vue?macro=true";
import { default as _91id_93MyHbtTLXQeVo8kVNabxXzgQgIJSbX0vFr04xcrM4vsgMeta } from "/app/packages/frontend/app/pages/manage/tournaments/[id].vue?macro=true";
import { default as _91id_93_46clientnN_R7a_453_45etOYb0WHNNI8J6csuRoIdD7WrhLK_45cpjnIMeta } from "/app/packages/frontend/app/pages/play/online/[id].client.vue?macro=true";
import { default as _91id_93uBGRwclTAAkwrx6DDJ2_45rPb6rdGuTB4Bmw2hETbr7bAMeta } from "/app/packages/frontend/app/pages/play/training/game/[id].vue?macro=true";
import { default as indexXYQ8QujPE1sGBpCoDjRNkjybRYcflMw1PrKdYdxTERIMeta } from "/app/packages/frontend/app/pages/manage/tournaments/index.vue?macro=true";
import { default as _91id_93EzBixYYOsPgp3fdIL8uHJDmiP0d0UWJPxMrcKNU_456JEMeta } from "/app/packages/frontend/app/pages/play/training/games/[id].vue?macro=true";
import { default as gameslB4SWcm2Lm1IdelojTf6Cqx6sNxayFhdb3CxKkDqCVEMeta } from "/app/packages/frontend/app/pages/tournaments/[tournament]/games.vue?macro=true";
import { default as indexhTsSdlKEd8vcnwx5HBit6mLyyYCzfyYalZTKuzQ8Z3IMeta } from "/app/packages/frontend/app/pages/tournaments/[tournament]/index.vue?macro=true";
import { default as groupsFDU6H6c43juWMe_t_45Afk9ERy_s2YS_458dXs9A3MbylEYMeta } from "/app/packages/frontend/app/pages/tournaments/[tournament]/groups.vue?macro=true";
import { default as resultspXCfk0G_uULoemPiuGw8wbwXQFuWW5BsxlpWoNeAU7EMeta } from "/app/packages/frontend/app/pages/tournaments/[tournament]/results.vue?macro=true";
import { default as winner_45bracketsuN5MvxayR9L9cMDtvzHIdYBQ8x1O_HPSXycx74RQDHkMeta } from "/app/packages/frontend/app/pages/tournaments/[tournament]/winner-brackets.vue?macro=true";
import { default as consolation_45brackets8yrTjvmIdPdvdBAxQqmQUxDYvTqXMQYX5VHg6vDBmOIMeta } from "/app/packages/frontend/app/pages/tournaments/[tournament]/consolation-brackets.vue?macro=true";
import { default as _91tournament_93eDI_45A3CB7e5Y6TIvbSQnKKB_UNh6uFp6zZ7CdsnKCPAMeta } from "/app/packages/frontend/app/pages/tournaments/[tournament].vue?macro=true";
import { default as boards__45PmkH8htEFYJZukzLJDQz4tgMcnSbQHZ800eXoTdhsMeta } from "/app/packages/frontend/app/pages/manage/events/[id]/boards.vue?macro=true";
import { default as indexx69aOXZE77aJqNTmgHDL49XV20rsLZ6WrezM2pM1GmQMeta } from "/app/packages/frontend/app/pages/manage/participants/index.vue?macro=true";
import { default as editvI_FjjnK_o4eMlWDcErqGCqk4ISRJ6ZZko37tPldmFUMeta } from "/app/packages/frontend/app/pages/manage/rankings/[id]/edit.vue?macro=true";
import { default as createF4RuuQ5AfI3KME23uC0rBPNE0c89hH7lldr5ybec_45joMeta } from "/app/packages/frontend/app/pages/manage/tournaments/create.vue?macro=true";
import { default as indexpfWfWs3s_59dXNUK5dcQJNbtS_45F3HGBve0CzgRxwdO8Meta } from "/app/packages/frontend/app/pages/play/training/games/index.vue?macro=true";
import { default as indexTu08yI96rZuCVLC6l5vGlH5AihZvHM6zksXTPHHcfi4Meta } from "/app/packages/frontend/app/pages/manage/rankings/[id]/index.vue?macro=true";
import { default as indexkdqPVZKI8UkJrLqQPHNY6CImw9xvXFedHJHZ90d7_O4Meta } from "/app/packages/frontend/app/pages/competition/[org_slug]/index.vue?macro=true";
import { default as my_45coachcgHPk_455f6Hdg3CnPrgGnn6dDLHd0R_45AtJ0ch8hDSBd8Meta } from "/app/packages/frontend/app/pages/play/training/coaching/my-coach.vue?macro=true";
import { default as my_45studentscevfAggqhit4PlUeHDGfkEts0uRTEFfUnPS7LNINKu4Meta } from "/app/packages/frontend/app/pages/play/training/coaching/my-students.vue?macro=true";
import { default as _91id_93qxxqxpfaM9ySkpbLncTXAkthwBTwPCyamSBA8xcqtqgMeta } from "/app/packages/frontend/app/pages/play/training/coaching/student/[id].vue?macro=true";
import { default as indexJsrLdUsZpF8V49ogIrccayavqMGOZn3VtxGBMwperIUMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news/index.vue?macro=true";
import { default as edituCpUjXbUJBa3M5JIZB4NJMNRT0yX1y_452ITx37cRlTLEMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news/[slug]/edit.vue?macro=true";
import { default as _91slug_93ZUNkLap80_eeUU0yZzHiwqOkx3QgztxUNp_zKMR34rUMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news/[slug].vue?macro=true";
import { default as create7gxErjPLdS3Ehzi2GNyktXvNWIicJHEayRhhsAXMScYMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news/create.vue?macro=true";
import { default as newsRAF8g6OP8MHfjTvcbbgFno6UCmeF_45aBhcOwTk5Ux1PoMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news.vue?macro=true";
import { default as settingsSUHPSWS4NxZU3o61z2JYFdkrsAbt1_45qGh73OqExnMRsMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/settings.vue?macro=true";
import { default as editFMzzEADwpVM0qFeb1e87l2Lb7Zv2a5DOtxRIDngPEyUMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents/[id]/edit.vue?macro=true";
import { default as _91id_93XgAur4O_3rtm_45szq_vd4dohVPtWtWOR3GIX2kG4PCpMMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents/[id].vue?macro=true";
import { default as index3sCzdxqLNuocdi21aUuwcVb9Ccfkj9JXnxreBMePwVIMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents/index.vue?macro=true";
import { default as createhT30oClGOJEb4XDOF0FDifT6pVCzl4VjH7oF0C5Th_45IMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents/create.vue?macro=true";
import { default as documentsG3urL2CrpOf5JjwAkb24g5LpVBf4Z0dryaE1EztWPSwMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents.vue?macro=true";
import { default as index827fZcPNja0uDLD_45Rq86aC_45A55REViZR7bNWlmiEdVgMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/board-members/index.vue?macro=true";
import { default as createVF6ShV0AqhzUBLn35HCOWbO9XuE3yvetWazWOB8UXwcMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/board-members/create.vue?macro=true";
import { default as editp7YDoZTPBjWlJp09UWRXSducT1xqtVDRosR4Cpab4XwMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/board-members/[id]/edit.vue?macro=true";
import { default as board_45memberscXmRRWO9dQdChwti_6W_45_45eFeqceKmIUxtTEp_45JZNFOwMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/board-members.vue?macro=true";
import { default as siteUpGqqTuTFW9LBT44CrYQcr6i9UMPWo0nkJGvf8GHHW4Meta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site.vue?macro=true";
import { default as indexDrqRjnPLcIUH9KYtbV20RnKQmvZ_oURA1C1_IT0oLkgMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/index.vue?macro=true";
import { default as indexJW12uPCOn6VLvgsllXGBPFP3YElkUJEhasm3DwQVaQEMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/index.vue?macro=true";
import { default as indexRzje9xU_9HCclgNJjgrZOfxlg0KQMaT9HHrrFv8objkMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/create/index.vue?macro=true";
import { default as existing_M0e0xUx_Q6sEumGDlzyXHeVmjQBdK8LPiwNaSKk2DUMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/create/existing.vue?macro=true";
import { default as createHDZ797m6UlizSJwJZSSst4oEp2hKI2WmH_NJLkBTqGEMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/create.vue?macro=true";
import { default as edituZHZOU4P3wcS0O1jsIud3uZJ_456QVqIenfYqxTJlX_SQMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/edit.vue?macro=true";
import { default as index5kFRzqnU8BuHasqV7pWMDVkSNMok9UCv8Cb5qknKDI4Meta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/index.vue?macro=true";
import { default as indextaQpdhUexlwC5eAyulvChRsQWxFlIbGlhswOVk2zB_wMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/members/index.vue?macro=true";
import { default as createZ3t1c2jBJ1B_zXWaLHLJNxaJXKLnhA0y218hB5R59zkMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/members/create.vue?macro=true";
import { default as editfSFFt3rg9_7LVPZGvNCqWSRGJEsJUor5PJv2L0ztrbQMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/members/[member_id]/edit.vue?macro=true";
import { default as _91team_slug_93h3oUM6pVkmKP3GUXXs9Hg7VaEd3p1p3poCau408reDkMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug].vue?macro=true";
import { default as teamsVKoy6_caO_45UOMatzjNqymwWcznCK9kJ_452BrrT9NjqXwMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams.vue?macro=true";
import { default as indexyq0lmJ3OEI9sDzCBZTfx7Hyw_5DSyIq1b7ItZzH_459FAMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/index.vue?macro=true";
import { default as createp9XE64PzrfgCUhbdBVsQlaaDeKHBgBi4E5Gk5c4b2RYMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/create.vue?macro=true";
import { default as edit8DINw1EM8x_Y2H0n1_hrYU5fQIUlOICfT3jiLliYcPQMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug]/edit.vue?macro=true";
import { default as index9m9S64rO_O6O53PnaoYNaiejU8pBg6RqI5gnt3Q_456_8Meta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug]/index.vue?macro=true";
import { default as teamsCkXTin5EUsTXcYx2sr4sO7Ve_45jF95CCdPselg21JxcgMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug]/teams.vue?macro=true";
import { default as matchesgD_45yDOj1Ajs7hQJbF8K4zxjtY0Bx0WO_fHvdKbJQAHsMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug]/matches.vue?macro=true";
import { default as _91group_slug_93Wihq6IKmPtMBYwLdBVqzQ5DeFadh4YwK5hGk0MQJyk8Meta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug].vue?macro=true";
import { default as groupsA3b8mWrI3f9m1iL6WVGHpRXzBI_dyzJ0nGLFAaLjeU4Meta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups.vue?macro=true";
import { default as indexWh5hDtduZV_Lz5zds0k3wqYx9Xq5DwHq5HJKRq2xceYMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/matches/index.vue?macro=true";
import { default as indexCCZ3MNGMocV1AIgcjGKKNVL6534NMMyr9goqls9DDAoMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/matches/[match_slug]/index.vue?macro=true";
import { default as matchesvhHFbvznImrhH_CUGwbyWYsoUfeaSCAOkos3GCfP_45mEMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/matches.vue?macro=true";
import { default as index2Gk5giCB3Gtb9ws8SvjGs08Lk_450uS6E4J1BrAbUnEYsMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons/index.vue?macro=true";
import { default as creategLq4tZGTA9htjDcvv3gQTFB7_45NUEIR7sDce_45I_GZ6QUMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons/create.vue?macro=true";
import { default as editQ5dQWNZ5ihtel4DEsxs3SZCaPE4_45q6nCssBpUzt6Gj4Meta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons/[manage_season_slug]/edit.vue?macro=true";
import { default as _91manage_season_slug_93npZUeQQFNmzW_45_454Tm1rUKydquIzV1nbeySo7em3I4X0Meta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons/[manage_season_slug].vue?macro=true";
import { default as seasonsrHySMiKAItb3LhNdz0UnhM_45CCL8DbUQByuFrOWTdLPgMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons.vue?macro=true";
import { default as indexowqxWMGh3SAKbi4eUo66Zw9Y58O_45Lgxlcnq6vuOscd4Meta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/index.vue?macro=true";
import { default as createoN_45O_MTDy8qErlqNJbidMlEG60MG71820pzFcDXLyFcMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/create.vue?macro=true";
import { default as edityw0cWXaEr544kI_WqH84yuGmJYzJZUfOSntncCv_45yf0Meta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/[location_id]/edit.vue?macro=true";
import { default as indexek01psbiyZz38lyhr3i4f2VBx_HEwXue0TxWcmRWHyoMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/[location_id]/index.vue?macro=true";
import { default as teamsPSs_5G_3iBOUCMKFMU4QuQdAMwBESE3NICIqhACWsKQMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/[location_id]/teams.vue?macro=true";
import { default as _91location_id_93DhT5suDlnjxc8J3B3mxD7iKYrBlt2Vabez9F1_3y6zgMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/[location_id].vue?macro=true";
import { default as locationsMzGiZG3OXy6_wdZhwYeDkgmgx1w0KlGlZZw23xVoVdkMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations.vue?macro=true";
import { default as _91season_slug_93tOjXmuemdDxAq3caP_bf1Z4godtT5ji_45sX3FLUiNNYEMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug].vue?macro=true";
import { default as _91game_id_930xEKem_p6G_6PkzE9gTgAWxmDyhnbwhE0_458KT_Z7tPUMeta } from "/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/matches/[match_slug]/play/[game_id].vue?macro=true";
import { default as locale_45redirectwWWuPAykl2PRfGpUgrGYql0WsNPUNcapGQ1rpP5yC7cMeta } from "/app/node_modules/.pnpm/nuxt-i18n-micro@1.84.1_magicast@0.3.5_vite@7.0.6_@types+node@24.1.0_jiti@2.5.1_lightnin_56cdcf6643c41b00d5efaeb335ecf7be/node_modules/nuxt-i18n-micro/dist/runtime/components/locale-redirect.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/packages/frontend/app/pages/index.vue")
  },
  {
    name: "tablet",
    path: "/tablet",
    meta: { ...(index_46client0zPajiQyZHKXnphwm6XzNDPUVi3CyQSa4WaCjOEVqiUMeta || {}), ...{"middleware":["board-auth"]} },
    component: () => createClientPage(() => import("/app/packages/frontend/app/pages/tablet/index.client.vue"))
  },
  {
    name: "tablet-login",
    path: "/tablet/login",
    meta: { ...(login_46clientaJ1FPYzoLXEN8KBq1KLjJv9EBUi5UszF3kEvT_9AxzMMeta || {}), ...{"middleware":["board-anonymous"]} },
    component: () => createClientPage(() => import("/app/packages/frontend/app/pages/tablet/login.client.vue"))
  },
  {
    name: "localized-index",
    path: "/:locale(en|nl|de)",
    component: () => import("/app/packages/frontend/app/pages/index.vue")
  },
  {
    name: "localized-live-id",
    path: "/:locale(en|nl|de)/live/:id()",
    component: () => import("/app/packages/frontend/app/pages/live/[id].vue")
  },
  {
    name: "localized-auth-login",
    path: "/:locale(en|nl|de)/auth/login",
    meta: { ...(loginFfMqkNXI_45M_lXnfLGuBE1NJVjonXeUR2VrLzydH8p2MMeta || {}), ...{"middleware":["anonymous"]} },
    component: () => import("/app/packages/frontend/app/pages/auth/login.vue")
  },
  {
    name: "localized-play",
    path: "/:locale(en|nl|de)/play",
    component: () => import("/app/packages/frontend/app/pages/play/index.vue")
  },
  {
    name: "localized-play-lobby",
    path: "/:locale(en|nl|de)/play/lobby",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/play/lobby.vue")
  },
  {
    name: "localized-test-login",
    path: "/:locale(en|nl|de)/test-login",
    component: () => import("/app/packages/frontend/app/pages/test-login.vue")
  },
  {
    name: "localized-admin-users-list",
    path: "/:locale(en|nl|de)/admin/users",
    meta: { ...(usersml8o3yB2_45CYxMI3MhxYB8zuHmq71i_45Vc4s845amGBM0Meta || {}), ...{"middleware":["superadmin"]} },
    component: () => import("/app/packages/frontend/app/pages/admin/users.vue"),
    children: [
  {
    name: "localized-admin-users-en",
    path: "",
    meta: {"middleware":["superadmin"]},
    component: () => import("/app/packages/frontend/app/pages/admin/users/index.vue")
  },
  {
    name: "localized-admin-users-nl",
    path: "",
    meta: {"middleware":["superadmin"]},
    component: () => import("/app/packages/frontend/app/pages/admin/users/index.vue")
  },
  {
    name: "localized-admin-users-de",
    path: "",
    meta: {"middleware":["superadmin"]},
    component: () => import("/app/packages/frontend/app/pages/admin/users/index.vue")
  },
  {
    name: "localized-admin-users-user_id-edit",
    path: ":user_id()/edit",
    component: () => import("/app/packages/frontend/app/pages/admin/users/[user_id]/edit.vue")
  }
]
  },
  {
    name: "localized-manage",
    path: "/:locale(en|nl|de)/manage",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/index.vue")
  },
  {
    name: "localized-auth-register",
    path: "/:locale(en|nl|de)/auth/register",
    meta: { ...(registertvbiYupARYf35jgh2Apc2Ep7xeegwLHKNubspqtLA2QMeta || {}), ...{"middleware":["anonymous"]} },
    component: () => import("/app/packages/frontend/app/pages/auth/register.vue")
  },
  {
    name: "localized-profile",
    path: "/:locale(en|nl|de)/profile",
    component: () => import("/app/packages/frontend/app/pages/profile/index.vue")
  },
  {
    name: "localized-rankings-id",
    path: "/:locale(en|nl|de)/rankings/:id()",
    component: () => import("/app/packages/frontend/app/pages/rankings/[id].vue")
  },
  {
    name: "localized-events-event",
    path: "/:locale(en|nl|de)/events/:event()",
    component: () => import("/app/packages/frontend/app/pages/events/[event].vue")
  },
  {
    name: "localized-privacy-policy",
    path: "/:locale(en|nl|de)/privacy-policy",
    component: () => import("/app/packages/frontend/app/pages/privacy-policy.vue")
  },
  {
    name: "localized-rankings",
    path: "/:locale(en|nl|de)/rankings",
    component: () => import("/app/packages/frontend/app/pages/rankings/index.vue")
  },
  {
    name: "localized-profile-my-stats",
    path: "/:locale(en|nl|de)/profile/my-stats",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/profile/my-stats.vue")
  },
  {
    name: "localized-profile-settings-page",
    path: "/:locale(en|nl|de)/profile/settings",
    meta: { ...(settingsavv21Jd_0BnioSGOt_45Ok2Epjk5DsGXctru00Yl9DcmkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/packages/frontend/app/pages/profile/settings.vue")
  },
  {
    name: "localized-terms-of-service",
    path: "/:locale(en|nl|de)/terms-of-service",
    component: () => import("/app/packages/frontend/app/pages/terms-of-service.vue")
  },
  {
    name: "localized-competition",
    path: "/:locale(en|nl|de)/competition",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/index.vue")
  },
  {
    name: "localized-tournaments",
    path: "/:locale(en|nl|de)/tournaments",
    component: () => import("/app/packages/frontend/app/pages/tournaments/index.vue")
  },
  {
    name: "localized-profile-my-matches",
    path: "/:locale(en|nl|de)/profile/my-matches",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/profile/my-matches.vue")
  },
  {
    name: "localized-admin-organisations-list",
    path: "/:locale(en|nl|de)/admin/organisations",
    meta: { ...(organisations7HPq7ICiLi6og6R7peWRSsS0NgnTaFOqnczrGcVx92QMeta || {}), ...{"middleware":["superadmin"]} },
    component: () => import("/app/packages/frontend/app/pages/admin/organisations.vue"),
    children: [
  {
    name: "localized-admin-organisations-en",
    path: "",
    meta: {"middleware":["superadmin"]},
    component: () => import("/app/packages/frontend/app/pages/admin/organisations/index.vue")
  },
  {
    name: "localized-admin-organisations-nl",
    path: "",
    meta: {"middleware":["superadmin"]},
    component: () => import("/app/packages/frontend/app/pages/admin/organisations/index.vue")
  },
  {
    name: "localized-admin-organisations-de",
    path: "",
    meta: {"middleware":["superadmin"]},
    component: () => import("/app/packages/frontend/app/pages/admin/organisations/index.vue")
  },
  {
    name: "localized-admin-organisations-create-en",
    path: "create",
    meta: {"middleware":["superadmin"]},
    component: () => import("/app/packages/frontend/app/pages/admin/organisations/create.vue")
  },
  {
    name: "localized-admin-organisations-create-nl",
    path: "create",
    meta: {"middleware":["superadmin"]},
    component: () => import("/app/packages/frontend/app/pages/admin/organisations/create.vue")
  },
  {
    name: "localized-admin-organisations-create-de",
    path: "create",
    meta: {"middleware":["superadmin"]},
    component: () => import("/app/packages/frontend/app/pages/admin/organisations/create.vue")
  },
  {
    name: "localized-org-slug",
    path: ":org_slug()",
    meta: {"middleware":["superadmin"]},
    component: () => import("/app/packages/frontend/app/pages/admin/organisations/[org_slug].vue"),
    children: [
  {
    name: "localized-admin-organisations-org_slug-edit-en",
    path: "edit",
    meta: {"middleware":["superadmin"]},
    component: () => import("/app/packages/frontend/app/pages/admin/organisations/[org_slug]/edit.vue")
  },
  {
    name: "localized-admin-organisations-org_slug-edit-nl",
    path: "edit",
    meta: {"middleware":["superadmin"]},
    component: () => import("/app/packages/frontend/app/pages/admin/organisations/[org_slug]/edit.vue")
  },
  {
    name: "localized-admin-organisations-org_slug-edit-de",
    path: "edit",
    meta: {"middleware":["superadmin"]},
    component: () => import("/app/packages/frontend/app/pages/admin/organisations/[org_slug]/edit.vue")
  },
  {
    name: "localized-admin-organisations-org_slug-en",
    path: "",
    meta: {"middleware":["superadmin"]},
    component: () => import("/app/packages/frontend/app/pages/admin/organisations/[org_slug]/index.vue")
  },
  {
    name: "localized-admin-organisations-org_slug-nl",
    path: "",
    meta: {"middleware":["superadmin"]},
    component: () => import("/app/packages/frontend/app/pages/admin/organisations/[org_slug]/index.vue")
  },
  {
    name: "localized-admin-organisations-org_slug-de",
    path: "",
    meta: {"middleware":["superadmin"]},
    component: () => import("/app/packages/frontend/app/pages/admin/organisations/[org_slug]/index.vue")
  }
]
  }
]
  },
  {
    name: "localized-auth-reset-password",
    path: "/:locale(en|nl|de)/auth/reset-password",
    meta: { ...(reset_45passwordS6jdXf3OFPPwomV6KYjm6X2_45REy65se_45MfAhrESs2nAMeta || {}), ...{"middleware":["anonymous"]} },
    component: () => import("/app/packages/frontend/app/pages/auth/reset-password.vue")
  },
  {
    name: "localized-play-offline",
    path: "/:locale(en|nl|de)/play/offline",
    component: () => createClientPage(() => import("/app/packages/frontend/app/pages/play/offline.client.vue"))
  },
  {
    name: "localized-play-training",
    path: "/:locale(en|nl|de)/play/training",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/play/training/index.vue")
  },
  {
    name: "localized-play-training-stats",
    path: "/:locale(en|nl|de)/play/training/stats",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/play/training/stats.vue")
  },
  {
    name: "localized-manage-events-create",
    path: "/:locale(en|nl|de)/manage/events/create",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/events/create.vue")
  },
  {
    name: "localized-play-bot-id",
    path: "/:locale(en|nl|de)/play/bot/:id()",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/app/packages/frontend/app/pages/play/bot/[id].client.vue"))
  },
  {
    name: "localized-manage-rankings",
    path: "/:locale(en|nl|de)/manage/rankings",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/rankings/index.vue")
  },
  {
    name: "localized-manage-rankings-create",
    path: "/:locale(en|nl|de)/manage/rankings/create",
    component: () => import("/app/packages/frontend/app/pages/manage/rankings/create.vue")
  },
  {
    name: "localized-profile-my-tournaments",
    path: "/:locale(en|nl|de)/profile/my-tournaments",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/profile/my-tournaments.vue")
  },
  {
    name: "localized-manage-events-locations",
    path: "/:locale(en|nl|de)/manage/events-locations",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/events-locations.vue")
  },
  {
    name: "localized-manage-events-id-edit",
    path: "/:locale(en|nl|de)/manage/events/:id()/edit",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/events/[id]/edit.vue")
  },
  {
    name: "localized-view-tournament-id",
    path: "/:locale(en|nl|de)/manage/tournaments/:id()",
    meta: { ...(_91id_93MyHbtTLXQeVo8kVNabxXzgQgIJSbX0vFr04xcrM4vsgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id].vue"),
    children: [
  {
    name: "localized-manage-tournaments-id-en",
    path: "",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/index.vue")
  },
  {
    name: "localized-manage-tournaments-id-nl",
    path: "",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/index.vue")
  },
  {
    name: "localized-manage-tournaments-id-de",
    path: "",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/index.vue")
  },
  {
    name: "localized-manage-tournaments-id-players-en",
    path: "players",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/players.vue")
  },
  {
    name: "localized-manage-tournaments-id-players-nl",
    path: "players",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/players.vue")
  },
  {
    name: "localized-manage-tournaments-id-players-de",
    path: "players",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/players.vue")
  },
  {
    name: "localized-manage-tournaments-id-play-list-en",
    path: "play/list",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/play/list.vue")
  },
  {
    name: "localized-manage-tournaments-id-play-list-nl",
    path: "play/list",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/play/list.vue")
  },
  {
    name: "localized-manage-tournaments-id-play-list-de",
    path: "play/list",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/play/list.vue")
  },
  {
    name: "localized-manage-tournaments-id-play-groups-en",
    path: "play/groups",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/play/groups.vue")
  },
  {
    name: "localized-manage-tournaments-id-play-groups-nl",
    path: "play/groups",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/play/groups.vue")
  },
  {
    name: "localized-manage-tournaments-id-play-groups-de",
    path: "play/groups",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/play/groups.vue")
  },
  {
    name: "localized-manage-tournaments-id-play-results-en",
    path: "play/results",
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/play/results.vue")
  },
  {
    name: "localized-manage-tournaments-id-play-results-nl",
    path: "play/results",
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/play/results.vue")
  },
  {
    name: "localized-manage-tournaments-id-play-results-de",
    path: "play/results",
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/play/results.vue")
  },
  {
    name: "localized-manage-tournaments-id-play-losers-ko-en",
    path: "play/losers-ko",
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/play/losers-ko.vue")
  },
  {
    name: "localized-manage-tournaments-id-play-losers-ko-nl",
    path: "play/losers-ko",
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/play/losers-ko.vue")
  },
  {
    name: "localized-manage-tournaments-id-play-losers-ko-de",
    path: "play/losers-ko",
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/play/losers-ko.vue")
  },
  {
    name: "localized-manage-tournaments-id-play-winners-ko-en",
    path: "play/winners-ko",
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/play/winners-ko.vue")
  },
  {
    name: "localized-manage-tournaments-id-play-winners-ko-nl",
    path: "play/winners-ko",
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/play/winners-ko.vue")
  },
  {
    name: "localized-manage-tournaments-id-play-winners-ko-de",
    path: "play/winners-ko",
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/[id]/play/winners-ko.vue")
  }
]
  },
  {
    name: "localized-play-online-id",
    path: "/:locale(en|nl|de)/play/online/:id()",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/app/packages/frontend/app/pages/play/online/[id].client.vue"))
  },
  {
    name: "localized-play-training-game-id",
    path: "/:locale(en|nl|de)/play/training/game/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/play/training/game/[id].vue")
  },
  {
    name: "localized-manage-tournaments",
    path: "/:locale(en|nl|de)/manage/tournaments",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/index.vue")
  },
  {
    name: "localized-play-training-games-id",
    path: "/:locale(en|nl|de)/play/training/games/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/play/training/games/[id].vue")
  },
  {
    name: "localized-tournaments-tournament-details",
    path: "/:locale(en|nl|de)/tournaments/:tournament()",
    meta: _91tournament_93eDI_45A3CB7e5Y6TIvbSQnKKB_UNh6uFp6zZ7CdsnKCPAMeta || {},
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament].vue"),
    children: [
  {
    name: "localized-tournaments-tournament-games-en",
    path: "games",
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament]/games.vue")
  },
  {
    name: "localized-tournaments-tournament-games-nl",
    path: "games",
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament]/games.vue")
  },
  {
    name: "localized-tournaments-tournament-games-de",
    path: "games",
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament]/games.vue")
  },
  {
    name: "localized-tournaments-tournament-en",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament]/index.vue")
  },
  {
    name: "localized-tournaments-tournament-nl",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament]/index.vue")
  },
  {
    name: "localized-tournaments-tournament-de",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament]/index.vue")
  },
  {
    name: "localized-tournaments-tournament-groups-en",
    path: "groups",
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament]/groups.vue")
  },
  {
    name: "localized-tournaments-tournament-groups-nl",
    path: "groups",
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament]/groups.vue")
  },
  {
    name: "localized-tournaments-tournament-groups-de",
    path: "groups",
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament]/groups.vue")
  },
  {
    name: "localized-tournaments-tournament-results-en",
    path: "results",
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament]/results.vue")
  },
  {
    name: "localized-tournaments-tournament-results-nl",
    path: "results",
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament]/results.vue")
  },
  {
    name: "localized-tournaments-tournament-results-de",
    path: "results",
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament]/results.vue")
  },
  {
    name: "localized-tournaments-tournament-winner-brackets-en",
    path: "winner-brackets",
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament]/winner-brackets.vue")
  },
  {
    name: "localized-tournaments-tournament-winner-brackets-nl",
    path: "winner-brackets",
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament]/winner-brackets.vue")
  },
  {
    name: "localized-tournaments-tournament-winner-brackets-de",
    path: "winner-brackets",
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament]/winner-brackets.vue")
  },
  {
    name: "localized-tournaments-tournament-consolation-brackets-en",
    path: "consolation-brackets",
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament]/consolation-brackets.vue")
  },
  {
    name: "localized-tournaments-tournament-consolation-brackets-nl",
    path: "consolation-brackets",
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament]/consolation-brackets.vue")
  },
  {
    name: "localized-tournaments-tournament-consolation-brackets-de",
    path: "consolation-brackets",
    component: () => import("/app/packages/frontend/app/pages/tournaments/[tournament]/consolation-brackets.vue")
  }
]
  },
  {
    name: "localized-manage-events-id-boards",
    path: "/:locale(en|nl|de)/manage/events/:id()/boards",
    component: () => import("/app/packages/frontend/app/pages/manage/events/[id]/boards.vue")
  },
  {
    name: "localized-manage-participants",
    path: "/:locale(en|nl|de)/manage/participants",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/participants/index.vue")
  },
  {
    name: "localized-manage-rankings-id-edit",
    path: "/:locale(en|nl|de)/manage/rankings/:id()/edit",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/manage/rankings/[id]/edit.vue")
  },
  {
    name: "localized-manage-tournaments-create",
    path: "/:locale(en|nl|de)/manage/tournaments/create",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/manage/tournaments/create.vue")
  },
  {
    name: "localized-play-training-games",
    path: "/:locale(en|nl|de)/play/training/games",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/play/training/games/index.vue")
  },
  {
    name: "localized-manage-rankings-id",
    path: "/:locale(en|nl|de)/manage/rankings/:id()",
    component: () => import("/app/packages/frontend/app/pages/manage/rankings/[id]/index.vue")
  },
  {
    name: "localized-competition-org_slug",
    path: "/:locale(en|nl|de)/competition/:org_slug()",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/index.vue")
  },
  {
    name: "localized-play-training-coaching-my-coach",
    path: "/:locale(en|nl|de)/play/training/coaching/my-coach",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/play/training/coaching/my-coach.vue")
  },
  {
    name: "localized-play-training-coaching-my-students",
    path: "/:locale(en|nl|de)/play/training/coaching/my-students",
    meta: {"middleware":["auth"]},
    component: () => import("/app/packages/frontend/app/pages/play/training/coaching/my-students.vue")
  },
  {
    name: "localized-play-training-coaching-student-id",
    path: "/:locale(en|nl|de)/play/training/coaching/student/:id()",
    component: () => import("/app/packages/frontend/app/pages/play/training/coaching/student/[id].vue")
  },
  {
    name: "localized-competition-org-slug-season-season-slug-details",
    path: "/:locale(en|nl|de)/competition/:org_slug()/season/:season_slug()",
    meta: { ...(_91season_slug_93tOjXmuemdDxAq3caP_bf1Z4godtT5ji_45sX3FLUiNNYEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-site-en",
    path: "site",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site.vue"),
    children: [
  {
    name: "localized-news-en",
    path: "news",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-site-news-en",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-news-slug",
    path: ":slug()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news/[slug].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-site-news-slug-edit-en",
    path: "edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news/[slug]/edit.vue")
  }
]
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-news-create-en",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news/create.vue")
  }
]
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-settings-en",
    path: "settings",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/settings.vue")
  },
  {
    name: "localized-documents-en",
    path: "documents",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-site-documents-id",
    path: ":id()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents/[id].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-site-documents-id-edit-en",
    path: "edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents/[id]/edit.vue")
  }
]
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-documents-en",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-documents-create-en",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents/create.vue")
  }
]
  },
  {
    name: "localized-board-members-en",
    path: "board-members",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/board-members.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-site-board-members-en",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/board-members/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-board-members-create-en",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/board-members/create.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-board-members-id-edit",
    path: ":id()/edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/board-members/[id]/edit.vue")
  }
]
  }
]
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-nl",
    path: "site",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site.vue"),
    children: [
  {
    name: "localized-news-nl",
    path: "news",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-site-news-nl",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-news-slug",
    path: ":slug()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news/[slug].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-site-news-slug-edit-nl",
    path: "edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news/[slug]/edit.vue")
  }
]
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-news-create-nl",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news/create.vue")
  }
]
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-settings-nl",
    path: "settings",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/settings.vue")
  },
  {
    name: "localized-documents-nl",
    path: "documents",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-site-documents-id",
    path: ":id()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents/[id].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-site-documents-id-edit-nl",
    path: "edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents/[id]/edit.vue")
  }
]
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-documents-nl",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-documents-create-nl",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents/create.vue")
  }
]
  },
  {
    name: "localized-board-members-nl",
    path: "board-members",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/board-members.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-site-board-members-nl",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/board-members/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-board-members-create-nl",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/board-members/create.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-board-members-id-edit",
    path: ":id()/edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/board-members/[id]/edit.vue")
  }
]
  }
]
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-de",
    path: "site",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site.vue"),
    children: [
  {
    name: "localized-news-de",
    path: "news",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-site-news-de",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-news-slug",
    path: ":slug()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news/[slug].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-site-news-slug-edit-de",
    path: "edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news/[slug]/edit.vue")
  }
]
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-news-create-de",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/news/create.vue")
  }
]
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-settings-de",
    path: "settings",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/settings.vue")
  },
  {
    name: "localized-documents-de",
    path: "documents",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-site-documents-id",
    path: ":id()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents/[id].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-site-documents-id-edit-de",
    path: "edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents/[id]/edit.vue")
  }
]
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-documents-de",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-documents-create-de",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/documents/create.vue")
  }
]
  },
  {
    name: "localized-board-members-de",
    path: "board-members",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/board-members.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-site-board-members-de",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/board-members/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-board-members-create-de",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/board-members/create.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-site-board-members-id-edit",
    path: ":id()/edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/site/board-members/[id]/edit.vue")
  }
]
  }
]
  },
  {
    name: "localized-competition-org_slug-season-season_slug-en",
    path: "",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-nl",
    path: "",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-de",
    path: "",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/index.vue")
  },
  {
    name: "localized-teams-en",
    path: "teams",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-teams-en",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/index.vue")
  },
  {
    name: "localized-create-en",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/create.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-teams-create-en",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/create/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-teams-create-existing-en",
    path: "existing",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/create/existing.vue")
  }
]
  },
  {
    name: "localized-team-slug",
    path: ":team_slug()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-teams-team_slug-edit-en",
    path: "edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/edit.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-teams-team_slug-en",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-teams-team_slug-members-en",
    path: "members",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/members/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-teams-team_slug-members-create-en",
    path: "members/create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/members/create.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-teams-team_slug-members-member_id-edit",
    path: "members/:member_id()/edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/members/[member_id]/edit.vue")
  }
]
  }
]
  },
  {
    name: "localized-teams-nl",
    path: "teams",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-teams-nl",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/index.vue")
  },
  {
    name: "localized-create-nl",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/create.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-teams-create-nl",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/create/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-teams-create-existing-nl",
    path: "existing",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/create/existing.vue")
  }
]
  },
  {
    name: "localized-team-slug",
    path: ":team_slug()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-teams-team_slug-edit-nl",
    path: "edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/edit.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-teams-team_slug-nl",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-teams-team_slug-members-nl",
    path: "members",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/members/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-teams-team_slug-members-create-nl",
    path: "members/create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/members/create.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-teams-team_slug-members-member_id-edit",
    path: "members/:member_id()/edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/members/[member_id]/edit.vue")
  }
]
  }
]
  },
  {
    name: "localized-teams-de",
    path: "teams",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-teams-de",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/index.vue")
  },
  {
    name: "localized-create-de",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/create.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-teams-create-de",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/create/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-teams-create-existing-de",
    path: "existing",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/create/existing.vue")
  }
]
  },
  {
    name: "localized-team-slug",
    path: ":team_slug()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-teams-team_slug-edit-de",
    path: "edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/edit.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-teams-team_slug-de",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-teams-team_slug-members-de",
    path: "members",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/members/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-teams-team_slug-members-create-de",
    path: "members/create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/members/create.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-teams-team_slug-members-member_id-edit",
    path: "members/:member_id()/edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/teams/[team_slug]/members/[member_id]/edit.vue")
  }
]
  }
]
  },
  {
    name: "localized-groups-en",
    path: "groups",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-groups-en",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-groups-create-en",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/create.vue")
  },
  {
    name: "localized-group-slug",
    path: ":group_slug()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-groups-group_slug-edit-en",
    path: "edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug]/edit.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-groups-group_slug-en",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug]/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-groups-group_slug-teams-en",
    path: "teams",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug]/teams.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-groups-group_slug-matches-en",
    path: "matches",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug]/matches.vue")
  }
]
  }
]
  },
  {
    name: "localized-groups-nl",
    path: "groups",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-groups-nl",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-groups-create-nl",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/create.vue")
  },
  {
    name: "localized-group-slug",
    path: ":group_slug()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-groups-group_slug-edit-nl",
    path: "edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug]/edit.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-groups-group_slug-nl",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug]/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-groups-group_slug-teams-nl",
    path: "teams",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug]/teams.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-groups-group_slug-matches-nl",
    path: "matches",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug]/matches.vue")
  }
]
  }
]
  },
  {
    name: "localized-groups-de",
    path: "groups",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-groups-de",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-groups-create-de",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/create.vue")
  },
  {
    name: "localized-group-slug",
    path: ":group_slug()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-groups-group_slug-edit-de",
    path: "edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug]/edit.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-groups-group_slug-de",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug]/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-groups-group_slug-teams-de",
    path: "teams",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug]/teams.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-groups-group_slug-matches-de",
    path: "matches",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/groups/[group_slug]/matches.vue")
  }
]
  }
]
  },
  {
    name: "localized-matches-en",
    path: "matches",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/matches.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-matches-en",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/matches/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-matches-match_slug",
    path: ":match_slug()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/matches/[match_slug]/index.vue")
  }
]
  },
  {
    name: "localized-matches-nl",
    path: "matches",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/matches.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-matches-nl",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/matches/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-matches-match_slug",
    path: ":match_slug()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/matches/[match_slug]/index.vue")
  }
]
  },
  {
    name: "localized-matches-de",
    path: "matches",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/matches.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-matches-de",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/matches/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-matches-match_slug",
    path: ":match_slug()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/matches/[match_slug]/index.vue")
  }
]
  },
  {
    name: "localized-seasons-en",
    path: "seasons",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-seasons-en",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-seasons-create-en",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons/create.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-seasons-manage_season_slug",
    path: ":manage_season_slug()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons/[manage_season_slug].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-seasons-manage_season_slug-edit-en",
    path: "edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons/[manage_season_slug]/edit.vue")
  }
]
  }
]
  },
  {
    name: "localized-seasons-nl",
    path: "seasons",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-seasons-nl",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-seasons-create-nl",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons/create.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-seasons-manage_season_slug",
    path: ":manage_season_slug()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons/[manage_season_slug].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-seasons-manage_season_slug-edit-nl",
    path: "edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons/[manage_season_slug]/edit.vue")
  }
]
  }
]
  },
  {
    name: "localized-seasons-de",
    path: "seasons",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-seasons-de",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-seasons-create-de",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons/create.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-seasons-manage_season_slug",
    path: ":manage_season_slug()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons/[manage_season_slug].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-seasons-manage_season_slug-edit-de",
    path: "edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/seasons/[manage_season_slug]/edit.vue")
  }
]
  }
]
  },
  {
    name: "localized-locations-en",
    path: "locations",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-locations-en",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-locations-create-en",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/create.vue")
  },
  {
    name: "localized-location-id",
    path: ":location_id()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/[location_id].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-locations-location_id-edit-en",
    path: "edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/[location_id]/edit.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-locations-location_id-en",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/[location_id]/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-locations-location_id-teams-en",
    path: "teams",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/[location_id]/teams.vue")
  }
]
  }
]
  },
  {
    name: "localized-locations-nl",
    path: "locations",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-locations-nl",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-locations-create-nl",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/create.vue")
  },
  {
    name: "localized-location-id",
    path: ":location_id()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/[location_id].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-locations-location_id-edit-nl",
    path: "edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/[location_id]/edit.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-locations-location_id-nl",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/[location_id]/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-locations-location_id-teams-nl",
    path: "teams",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/[location_id]/teams.vue")
  }
]
  }
]
  },
  {
    name: "localized-locations-de",
    path: "locations",
    meta: {"middleware":"auth"},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations.vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-locations-de",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-locations-create-de",
    path: "create",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/create.vue")
  },
  {
    name: "localized-location-id",
    path: ":location_id()",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/[location_id].vue"),
    children: [
  {
    name: "localized-competition-org_slug-season-season_slug-locations-location_id-edit-de",
    path: "edit",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/[location_id]/edit.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-locations-location_id-de",
    path: "",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/[location_id]/index.vue")
  },
  {
    name: "localized-competition-org_slug-season-season_slug-locations-location_id-teams-de",
    path: "teams",
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/locations/[location_id]/teams.vue")
  }
]
  }
]
  }
]
  },
  {
    name: "localized-competition-org_slug-season-season_slug-matches-match_slug-play-game_id",
    path: "/:locale(en|nl|de)/competition/:org_slug/season/:season_slug/matches/:match_slug/play/:game_id",
    meta: _91game_id_930xEKem_p6G_6PkzE9gTgAWxmDyhnbwhE0_458KT_Z7tPUMeta || {},
    component: () => import("/app/packages/frontend/app/pages/competition/[org_slug]/season/[season_slug]/matches/[match_slug]/play/[game_id].vue")
  },
  {
    name: "custom-fallback-route",
    path: "/:pathMatch(.*)*",
    meta: {"globalLocaleRoutes":{"tablet":false,"tablet-login":false}},
    component: () => import("/app/node_modules/.pnpm/nuxt-i18n-micro@1.84.1_magicast@0.3.5_vite@7.0.6_@types+node@24.1.0_jiti@2.5.1_lightnin_56cdcf6643c41b00d5efaeb335ecf7be/node_modules/nuxt-i18n-micro/dist/runtime/components/locale-redirect.vue")
  }
]